import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MotionConfig, motion } from 'framer-motion';
import s from './Chips.module.css';
/**
 * Mutually exclusive choices in a row — a status filter, a page's sections. The
 * picked one is inverted and the pill slides over to it.
 */
export function Chips({ id, label, value, options, onChange, }) {
    return (_jsx(MotionConfig, { reducedMotion: "user", children: _jsx("div", { className: s.chips, role: "group", "aria-label": label, children: options.map(([v, text]) => (_jsxs("button", { type: "button", className: s.chip, "aria-pressed": v === value, onClick: () => onChange(v), children: [v === value && (_jsx(motion.span, { layoutId: id, className: s.pill, transition: { type: 'spring', stiffness: 500, damping: 38 } })), _jsx("span", { className: s.text, children: text })] }, v === '' ? '_all' : v))) }) }));
}
